import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import config from '../../envconfig';
import { Table, FormControl, InputGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../common/UserContext';

const InventoryWidget = () => {
  const [inventory, setInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  // const [tooltip, setTooltip] = useState({ visible: false, content: '', x: 0, y: 0 });
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  console.log("jfjfjdf________________fdjfgbjd");

  const navigate = useNavigate();
  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/api/inventorywidget/${selectedScpId}`);
        setInventory(response.data);
        setFilteredInventory(response.data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchInventory();
  }, [selectedScpId]);

  // useEffect(() => {
  //   const filterData = () => {
  //     const lowercasedFilter = searchTerm.toLowerCase();
  //     const filtered = inventory.filter(item =>
  //       item.PL_ProductName.toLowerCase().includes(lowercasedFilter) ||
  //       item.PL_ProductCode.toLowerCase().includes(lowercasedFilter)
  //     );
  //     setFilteredInventory(filtered);
  //   };

  //   filterData();
  // }, [searchTerm, inventory]);
  const handleClick = () => {
    // Perform any other logic you want before navigation, if necessary
    console.log("HANDLE CLICK")
    navigate('/dashboard/inventory');  // This navigates to the dashboard route
  };
 
  useEffect(() => {
    const filterData = () => {
      const lowercasedFilter = searchTerm ? searchTerm.toLowerCase() : ''; // Handle empty search term
      const filtered = inventory.filter(item => 
        (item.PL_ProductName && item.PL_ProductName.toLowerCase().includes(lowercasedFilter)) ||
        (item.PL_ProductCode && item.PL_ProductCode.toLowerCase().includes(lowercasedFilter))
      );
      setFilteredInventory(filtered);
    };
  
    filterData();
  }, [searchTerm, inventory]);
  
  return (
    <>
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <InputGroup className="mb-3" style={{ width: '100%' }}>
        <FormControl
          placeholder="Search by Product Name or Product Code"
          aria-label="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>
      <div style={{ flexGrow: 1, width: '100%', height: '100%', overflow: 'auto' }}>
        <Table responsive bordered hover style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Available Qty</th>
            </tr>
          </thead>
          <tbody>
            {filteredInventory.length > 0 ? (
              filteredInventory.map((item, index) => (
                <tr
                  key={index}
                  onClick={handleClick}
                >
                  <td>{item.PL_ProductName}</td>
                  <td>{item.inv_availableqty}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="text-center">No Records Found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
     
    </div>
     {/* {tooltip.visible && (
        <div
          style={{
            position: 'fixed',
            top: tooltip.y - 150,
            left: tooltip.x - 750,
            backgroundColor: '#295a80',
            border: '1px solid #ddd',
            padding: '10px',
            color:'black',
            borderRadius: '5px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            zIndex: '10',
            whiteSpace: 'pre-line',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
            opacity: tooltip.visible ? 1 : 0,
            transform: tooltip.visible ? 'translateY(0)' : 'translateY(-10px)'
          }}
        >
          {tooltip.content}
        </div>
      )} */}
      </>
  );
};

export default InventoryWidget;
